
import BlogPreview from '~/components/blog/BlogPreview.vue';
import CheckoutPortfolio from '~/components/community/CheckoutPortfolio.vue';
import IconArrowRight from '~/components/icons/IconArrowRight.vue';
import SmallNewCareerCta from '~/components/navigation/SmallNewCareerCta.vue';
import CommunityDetailsHeadline from '~/components/page-components/communitypage/CommunityDetailsHeadline.vue';
import CommunityDetailsIntro from '~/components/page-components/communitypage/CommunityDetailsIntro.vue';
export default {
  components: { CommunityDetailsIntro, CommunityDetailsHeadline, CheckoutPortfolio, SmallNewCareerCta, BlogPreview, IconArrowRight },
  props: {
    imageDesktop: {
      type: String,
      required: true
    },
    imageTablet: {
      type: String,
      required: true
    },
    imageMobile: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: true
    },
    headline: {
      type: String,
      required: true
    },
    statement: {
      type: String,
      required: true
    },
    textHeadline: {
      type: String,
      required: true
    },
    textblocks: {
      type: Array,
      required: true,
      validator: (value) => {
        return value.length > 0 && value.every(v => typeof v === 'string');
      }
    },
    backgroundPosition: {
      type: String,
      default: 'center center'
    },
    blogPreviewHeadline: {
      type: String,
      default: ''
    },
    blogPreviewTopic: {
      type: String,
      default: ''
    },
    blogPreviewDate: {
      type: Date,
      default: () => new Date()
    },
    blogPreviewDescription: {
      type: String,
      default: ''
    },
    blogPreviewTags: {
      type: Array,
      default: () => []
    },
    blogPreviewImage: {
      type: String,
      default: 'https://ufswebsitefotos.s3.eu-central-1.amazonaws.com/blog/blog_gesine_650.jpg'
    },
    blogPreviewLink: {
      type: String,
      default: ''
    },
    blogPreviewReadingTime: {
      type: String,
      default: '1 min'
    }
  }

};
